import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import '../styles/main.scss';

console.log('index.js')

